import { baseApi } from "../baseApi";

export const BlogApi = baseApi.injectEndpoints({

  endpoints: (builder) => ({

    createBlog: builder.mutation({
      query: (formData) => ({
        url: "/blog-category-create",
        method: "POST",
        body: formData,
      }),

      invalidatesTags: ["Blog"],
    }),

    getBlog: builder.query({
      query: ({ page = 1,limit = 10,search = "",status = "",}={}) => "/blog-category-list",
      providesTags: ["Blog"],
    }),

    updateBlog: builder.mutation({
      query: ({ id, formData }) => ({
        url: `/blog-category-edit/${id}`,
        method: "POST",
        body: formData,
      }),

      invalidatesTags: ["Blog"],
    }),

    changeBlogStatus: builder.mutation({
      query: (id) => ({
        url: `/category-status/${id}`,
        method: "GET",
      }),

      invalidatesTags: ["Category"],
    }),

    deleteBlog: builder.mutation({
      query: (data) => ({
        url: `/blog-category-delete`,
        method: "DELETE",
        body:data
      }),
      invalidatesTags: ["Blog"],
    }),

  }),

});

export const {
  useCreateBlogMutation,
  useGetBlogQuery,
  useUpdateBlogMutation,
  useDeleteBlogMutation,

} = BlogApi;